import { ResizeAPI } from '@wix/thumbnail-generator';
import { isEditorX } from '../../utils/editorx';
export var defaultSettings = {
  apiUrl: isEditorX ? 'https://www.editorx.com' : 'https://www.wix.com',
  recommendedPreferencesApiUrl: isEditorX ? 'https://files.editorx.com' : 'https://files.wix.com',
  itemsLimit: 50,
  itemsCacheCapacity: 0,
  topicsListApiUrl: isEditorX ? 'https://www.editorx.com' : 'https://www.wix.com',
  publicMedia: {
    filesUrl: 'https://static.wixstatic.com',
    videoFilesUrl: 'https://video.wixstatic.com',
    imageOperationsApi: ResizeAPI.Vanbrandt,
    thumbnailSizes: {
      thumbnail: {
        width: 210,
        height: 210,
        mode: 'fill'
      },
      thumbnailFit: {
        width: 210,
        height: 210,
        mode: 'fit'
      },
      preview: {
        width: 375,
        height: 375,
        mode: 'fit'
      }
    }
  }
};